// Projectsimage.jsx
import React from 'react';
import './projectsimage.css';
import { Link } from 'react-router-dom';

// Rendered as a real <a href> (not an onClick navigate) so search engines can
// discover and crawl each project page from the portfolio.
const Projectsimage = ({ index, title, setModal, niech, url }) => {
    return (
        <Link
            to={`/${url}`}
            className="project1"
            onMouseEnter={() => {
                setModal({ active: true, index: index });
            }}
            onMouseLeave={() => {
                setModal({ active: false, index: index });
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2>{title}</h2>
                <h6 style={{ marginTop: "10px" }}>{niech}</h6>
            </div>
        </Link>
    );
}

export default Projectsimage;
